import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared/shared.module';
import { MobileFooterComponent } from './mobile-footer.component';
import { MaterialMdcModule } from 'src/app/shared/material-mdc.module';
import { MatBadgeModule } from '@angular/material/badge';


@NgModule({
  declarations: [MobileFooterComponent],
  imports: [
    CommonModule,
    SharedModule,
    MaterialMdcModule,
    MatBadgeModule
  ],
  exports: [
    MobileFooterComponent
  ]
})
export class MobileFooterModule { }
